module.exports = __webpack_public_path__ + "img/icone-color.2d591c86.webp";